import { render } from "./MaternalMortality.vue?vue&type=template&id=0acb9528&scoped=true"
import script from "./MaternalMortality.vue?vue&type=script&lang=js"
export * from "./MaternalMortality.vue?vue&type=script&lang=js"

import "./MaternalMortality.vue?vue&type=style&index=0&id=0acb9528&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acb9528"]])

export default __exports__